export default {
  USERNAME_EDIT: "USERNAME_EDIT",
  ENTER_OTP: "ENTER_OTP",
  USER_ID_SUBMIT: "USER_ID_SUBMIT",
  POPUP_SUBMIT: "POPUP_SUBMIT",
  FORGOT_PASS_RESET: "FORGOT_PASS_RESET",
  OTP_SUBMIT: "OTP_SUBMIT",
  RESEND_OTP: "RESEND_OTP",
  RESEND_OTP_FAILURE: "RESEND_OTP_FAILURE",
  RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
  ENTER_OLDPASSWORD: "ENTER_OLDPASSWORD",
  ENTER_NEWPASSWORD: "ENTER_NEWPASSWORD",
  CONFIRM_PASSWORD: "CONFIRM_PASSWORD",
  SUBMIT_PASSWORD: "SUBMIT_PASSWORD",
  USER_ID_SUBMIT_SUCCESS: "USER_ID_SUBMIT_SUCCESS",
  USER_ID_SUBMIT_FAILURE: "USER_ID_SUBMIT_FAILURE",
  OTP_SUBMIT_SUCCESS: "OTP_SUBMIT_SUCCESS",
  OTP_SUBMIT_FAILURE: "OTP_SUBMIT_FAILURE",
  NEW_PASSWORD_SUBMIT_SUCCESS: " NEW_PASSWORD_SUBMIT_SUCCESS",
  NEW_PASSWORD_SUBMIT_FAILURE: "NEW_PASSWORD_SUBMIT_FAILURE",
  CHANGE_PASS_SUBMIT_FAILURE: "CHANGE_PASS_SUBMIT_FAILURE",
  CHANGE_PASS_SUBMIT_SUCCESS: "CHANGE_PASS_SUBMIT_SUCCESS",
  ENTER_NEW_PIN: "ENTER_NEW_PIN",
  CONFIRM_PIN: "CONFIRM_PIN",
  SUBMIT_NEW_PIN: "SUBMIT_NEW_PIN",
  NEW_PIN_SUBMIT_SUCCESS: "NEW_PIN_SUBMIT_SUCCESS",
  NEW_PIN_SUBMIT_FAILURE: " NEW_PIN_SUBMIT_FAILURE",
  ENTER_PIN: "ENTER_PIN",
  SUBMIT_PIN: "SUBMIT_PIN",
  SUBMIT_PIN_SUCCESS: "SUBMIT_PIN_SUCCESS",
  SUBMIT_PIN_FAILURE: "SUBMIT_PIN_FAILURE",
  FORGOT_PIN: "FORGOT_PIN",
}